import { createFileRoute } from '@tanstack/react-router';

import * as DataIngestion from '@mint-sdk/api-data-ingestion';
import { z } from 'zod';

const searchSchema = z.object({
  search: z.string().prefault(''),
  pageNumber: z.number().prefault(1),
  itemsPerPage: z.number().prefault(50),
});

export const Route = createFileRoute(
  '/_secured/external-data/import-hub/custom-metrics',
)({
  staleTime: 30 * 1000,
  validateSearch: searchSchema,
  loaderDeps: ({ search }) => ({ search }),
  loader: async ({ context: { serviceLocator }, deps, cause }) => {
    if (cause === 'stay') {
      return;
    }

    const queryClient = await serviceLocator.getOrThrowInstance('queryClient');

    const initialQueryOptions =
      DataIngestion.CustomMetrics.getCustomMetricsQueryOptions({
        params: {},
      });
    const activeQueryOptions =
      DataIngestion.CustomMetrics.getCustomMetricsQueryOptions({
        params: {
          search: deps.search.search,
        },
      });

    queryClient.prefetchQuery(initialQueryOptions);
    queryClient.prefetchQuery(activeQueryOptions);
  },
});
